module.exports = __webpack_public_path__ + "img/realize4.25fc0aa2.png";